import axios from 'axios';

const baseApiUrl = 'api/organization-preview/public';

export default class OrganizationPreviewPublicService {
  public getAdvertisements(organizationId: number, type?: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let url = `${baseApiUrl}/${organizationId}/advertisements?sort=id,desc`;
      if (type) {
        url += `&type=${type}`;
      }
      axios
        .get(url)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getInfrastructures(organizationId: number, type?: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let url = `${baseApiUrl}/${organizationId}/infrastructures?sort=id,desc`;
      if (type) {
        url += `&type=${type}`;
      }
      axios
        .get(url)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getServices(organizationId: number, type?: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let url = `${baseApiUrl}/${organizationId}/services?sort=id,desc`;
      if (type) {
        url += `&type=${type}`;
      }
      axios
        .get(url)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
